import type { BodyRequest } from '@pba/react-utils';
import type { CredentialResponse } from '@react-oauth/google';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OauthTokenDataObject } from 'models/service/login';

type SocialLoginRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  code: CredentialResponse['credential'];
  organization_id?: string;
  organization_slug: string;
  provider: string;
  time_zone: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const loginWithSocial = async ({ body }: BodyRequest<SocialLoginRequest>) =>
  apiClient.post<OauthTokenDataObject, ApiClientResponse<OauthTokenDataObject>>(routes.user.oauth, body, {
    skipAuth: true,
  });
